// extracted by mini-css-extract-plugin
export default {"container":"Orders_container__-NnOz","orders_container":"Orders_orders_container__OigRE"};